/* eslint-disable no-restricted-imports */
import { CollectionModel } from '../../../data-layer/collections/types';
import { getRelativeTime } from '../../../utils/getRelativeTime';
import { pluralize } from '../../../utils/pluralize';

export const getMetaInfo = (collection?: CollectionModel) => {
    if (!collection) {
        return '';
    }
    const { createdAt, numberOfPosts, likes } = collection;

    const parts: string[] = [];

    // Добавляем информацию о постах, если она есть
    if (numberOfPosts !== undefined && numberOfPosts !== null) {
        const postsText = `${numberOfPosts} ${pluralize(numberOfPosts, 'пост', 'поста', 'постов')}`;
        parts.push(postsText);
    }

    // Добавляем информацию о лайках только если их больше 0
    if (likes !== undefined && likes !== null && likes > 0) {
        const likesText = `${likes} ${pluralize(likes, 'лайк', 'лайка', 'лайков')}`;
        parts.push(likesText);
    }

    // Добавляем информацию о времени, если дата создания есть
    if (createdAt) {
        const timeText = getRelativeTime(createdAt);
        parts.push(timeText);
    }

    return parts.join(' ・ ');
};
